import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from "exc-core";
import {ExcRestService} from "exc-rest";

@Component({
  selector: 'app-review-list-open-item',
  templateUrl: './review-list-open-item.component.html',
  styles: []
})
export class ReviewListOpenItemComponent extends ExcTranslation implements OnInit {
  @Input() data: any = null;
  @Input() previewMode: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  getAvatarClass() {
    return this.data.AuditType === 16
      ? this.data.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary'
      : this.data.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
  }
}
